import { render, staticRenderFns } from "./CustomItemModal.vue?vue&type=template&id=bbc6f24a&scoped=true"
import script from "./CustomItemModal.vue?vue&type=script&lang=js"
export * from "./CustomItemModal.vue?vue&type=script&lang=js"
import style0 from "./CustomItemModal.vue?vue&type=style&index=0&id=bbc6f24a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc6f24a",
  null
  
)

export default component.exports